import { render, staticRenderFns } from "./pesananbuktiiklanfrm.vue?vue&type=template&id=22c04fe6"
import script from "./pesananbuktiiklanfrm.vue?vue&type=script&lang=js"
export * from "./pesananbuktiiklanfrm.vue?vue&type=script&lang=js"
import style0 from "./pesananbuktiiklanfrm.vue?vue&type=style&index=0&id=22c04fe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports